import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgoraConfigService } from 'src/AgoraConfigService';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketTransferService {

  commonHeaders:any;
  agoraConfigObject: any;
  constructor(private http: HttpClient, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
      this.commonHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
  }

  pushMesssageToProducer(meetingId:any,message: any) {
    message.sentBy = localStorage.getItem("userId");
    message.meetingId = meetingId;
    return this.http.post(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.collaboration}`+"producer/"+meetingId, JSON.stringify(message), { headers:this.commonHeaders, observe: 'response',responseType: 'text'});
}
pushTypingNotification(meetingId:any,message: any,elementId:any) {
    message.sentBy = localStorage.getItem("userId");
    message.elementId = elementId;
    message.typingInfo = "Kala is Typing";
    return this.http.post(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.collaboration}`+"producer/"+meetingId, JSON.stringify(message), { headers:this.commonHeaders, observe: 'response',responseType: 'text'});
}
pushUserLoggedInStatus(meetingId:any,message: any) {
  message.sentBy = localStorage.getItem("userId");
  message.logTime = new Date();
  return this.http.post(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.collaboration}`+"meetingusers/"+meetingId, JSON.stringify(message), { headers:this.commonHeaders, observe: 'response',responseType: 'text'});
}
getUserLoggedInStatus(meetingId:any,message: any) {
  return this.http.post(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.collaboration}`+"usersstatus/"+meetingId, JSON.stringify(message), { headers:this.commonHeaders, observe: 'response',responseType: 'text'});
}
}
